import api from './api';
import { UserLoginDto } from '../types/types';

interface LoginResponse {
    token: string;
}

export const authService = {
    // Login user
    login: async (credentials: UserLoginDto): Promise<LoginResponse> => {
        const response = await api.post<LoginResponse>('/auth/login', credentials);
        return response.data;
    },

    // Register user (if needed)
    register: async (userData: { username: string; password: string; role: string }): Promise<void> => {
        await api.post('/auth/register', userData);
    },

    // Logout user
    logout: (): void => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    },

    // Check if user is authenticated
    isAuthenticated: (): boolean => {
        const token = localStorage.getItem('token');
        console.log('isAuthenticated - token exists:', !!token);
        
        if (!token) return false;

        // Optional: Check expiration
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const exp = payload.exp * 1000;
            const now = Date.now();
            console.log('isAuthenticated - exp:', new Date(exp), 'now:', new Date(now), 'valid:', now < exp);
            
            if (now >= exp) {
                console.log('Token expired, logging out');
                authService.logout();
                return false;
            }
            console.log('Token is valid');
            return true;
        } catch (e) {
            console.error('Error parsing token:', e);
            return false;
        }
    },

    // Get token
    getToken: (): string | null => {
        return localStorage.getItem('token');
    },

    // Get user permissions
    getPermissions: (): string[] => {
        const token = localStorage.getItem('token');
        if (!token) return [];
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.permissions ? payload.permissions.split(',') : [];
        } catch (e) {
            return [];
        }
    },

    // Check if user has specific permission
    hasPermission: (permission: string): boolean => {
        const token = localStorage.getItem('token');
        if (!token) return false;

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));

            // robust check for role claim (can be URL or simple string)
            const role = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || payload['role'];

            // Bypass for Admin
            if (role === 'Admin') return true;

            const permissions = payload.permissions ? payload.permissions.split(',') : [];
            return permissions.includes(permission);
        } catch (e) {
            return false;
        }
    },

    // Get user role from JWT token
    getUserRole: (): string | null => {
        const token = localStorage.getItem('token');
        if (!token) return null;

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            // Handle both claim formats
            return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || payload['role'] || null;
        } catch (e) {
            return null;
        }
    },

    // Get username from JWT token
    getUsername: (): string | null => {
        const token = localStorage.getItem('token');
        if (!token) return null;

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            // Handle both claim formats
            return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/name'] || payload['name'] || payload['unique_name'] || null;
        } catch (e) {
            return null;
        }
    }
};
